import BaseService from "../../BaseService";

const { http } = BaseService();
const controller = "Logger";

export function GetPagingParams(postdata) {
  const data = { ...postdata };
  return http({
    url: controller + "/get-paging-params",
    method: "post",
    data,
  });
}
